import { Fraction, JSBI } from '@fusionx/sdk'

export const ZERO_FRACTION = new Fraction(JSBI.BigInt(0), JSBI.BigInt(100))
